import templateUrl from './slingTipComponent.html';

export default {
  controller: SlingTipCtrl,
  bindings: {
    isVisible: '<',
    onDismiss: '&?',
  },
  transclude: true,
  controllerAs: 'ctrl',
  templateUrl,
};

function SlingTipCtrl() {
  'ngInject';

  const controller = this;

  controller.dismiss = dismiss;

  function dismiss() {
    controller.isVisible = false;
    controller.onDismiss();
  }
}
